import { render, staticRenderFns } from "./CommentListTable.vue?vue&type=template&id=50ad58fa&scoped=true&"
import script from "./CommentListTable.vue?vue&type=script&lang=ts&"
export * from "./CommentListTable.vue?vue&type=script&lang=ts&"
import style0 from "./CommentListTable.vue?vue&type=style&index=0&id=50ad58fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ad58fa",
  null
  
)

export default component.exports